const QUOTES = [
  {
    q: "We replaced an entire onboarding app with a single WhatsApp thread. Activation went up 41%.",
    by: "Head of Product · Series B fintech",
  },
  {
    q: "The email workflow felt strange for two weeks. Then I realized I had my evenings back.",
    by: "Founder · D2C wellness",
  },
  {
    q: "Other agencies sent gantt charts. ISD sent something working on Friday.",
    by: "COO · Logistics platform",
  },
  {
    q: "It's the calmest engineering relationship we've ever had — and the most thorough.",
    by: "CTO · Healthcare SaaS",
  },
];

const LOGOS = ["The 143", "Prime Automations", "ConversationLayer.ai", "Cast Creative", "The 4 Hour Day", "Open Space Events", "Future of Value"];

export default function SocialProof() {
  return (
    <section
      data-testid="social-proof-section"
      className="relative py-24 md:py-32 border-b border-white/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-12">
          <span className="text-xs uppercase tracking-[0.22em] text-zinc-500 font-mono">
            §06 · Quiet Endorsements
          </span>
        </div>

        <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-light leading-snug max-w-3xl mb-16">
          The people we've built for
          <br />
          <span className="text-zinc-500">tend not to shout about it.</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10 mb-16">
          {QUOTES.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#050505] p-8 md:p-10 hover:bg-[#0a0a0a] transition-colors"
            >
              <div className="font-heading text-3xl font-extralight text-yellow-400 leading-none mb-4">"</div>
              <blockquote className="font-heading text-xl font-light text-white leading-snug tracking-tight">
                {t.q}
              </blockquote>
              <figcaption className="mt-6 pt-4 border-t border-white/10 font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-500">
                {t.by}
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Trust strip */}
        <div className="grid md:grid-cols-4 gap-px bg-white/10 border border-white/10 mb-16">
          {[
            { k: "99.9%", v: "Uptime SLA" },
            { k: "SOC 2", v: "Type II aligned" },
            { k: "AES-256", v: "At rest & transit" },
            { k: "<5 min", v: "Incident response" },
          ].map((t) => (
            <div key={t.v} className="bg-[#050505] p-6 text-center">
              <div className="font-heading text-2xl font-light text-white">{t.k}</div>
              <div className="text-xs uppercase tracking-[0.22em] text-zinc-500 mt-2 font-mono">{t.v}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee */}
      <div className="relative border-y border-white/10 py-8 bg-black/40">
        <div className="flex whitespace-nowrap animate-marquee">
          {[...LOGOS, ...LOGOS].map((l, i) => (
            <span
              key={i}
              className="font-heading text-2xl md:text-3xl font-extralight tracking-tight text-zinc-600 px-10 flex items-center gap-10"
            >
              {l}
              <span className="w-1 h-1 bg-zinc-700 inline-block" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
